module.exports = __webpack_public_path__ + "static/media/retro-full.e1e56ee9.png";